/* ============================================================
   NOIRBASICS v2 — global.js
   Header state, reveal-on-scroll, cart drawer (AJAX),
   product variants, quick-add, mobile nav, newsletter.
   ============================================================ */
(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const money = (cents) =>
    (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });

  /* ---------- sticky header state ---------- */
  const header = $('[data-site-header]');
  const onScroll = () => {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 24);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- reveal on scroll ---------- */
  const revealEls = $$('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-visible'));
  }

  /* ---------- mobile navigation ---------- */
  const menuToggle = $('[data-menu-toggle]');
  const mobileNav = $('[data-mobile-nav]');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- cart drawer ---------- */
  const drawer = $('[data-cart-drawer]');
  const veil = $('[data-cart-veil]');
  const countBubbles = $$('[data-cart-count]');

  function setCount(count) {
    countBubbles.forEach((b) => {
      b.textContent = count;
      b.classList.toggle('is-hidden', count === 0);
    });
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (veil) veil.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    renderDrawer();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (veil) veil.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  $$('[data-cart-open]').forEach((btn) =>
    btn.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); })
  );
  $$('[data-cart-close]').forEach((btn) => btn.addEventListener('click', closeDrawer));
  if (veil) veil.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  function drawerItemHTML(item) {
    const variant = item.variant_title && item.variant_title !== 'Default Title'
      ? `<div class="cart-drawer__variant">${item.variant_title}</div>` : '';
    return `
      <div class="cart-drawer__item" data-line="${item.key}">
        <a class="cart-drawer__media" href="${item.url}">
          <img src="${item.image}" alt="${item.title.replace(/"/g, '&quot;')}" loading="lazy">
        </a>
        <div>
          <a class="cart-drawer__name" href="${item.url}">${item.product_title}</a>
          ${variant}
          <div class="cart-drawer__qty">
            <button type="button" data-drawer-dec="${item.key}" aria-label="Weniger">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-drawer-inc="${item.key}" aria-label="Mehr">+</button>
          </div>
          <button type="button" class="cart-drawer__remove" data-drawer-remove="${item.key}">Entfernen</button>
        </div>
        <div class="cart-drawer__price">${money(item.final_line_price)}</div>
      </div>`;
  }

  async function renderDrawer() {
    const itemsEl = $('[data-drawer-items]');
    const footEl = $('[data-drawer-foot]');
    if (!itemsEl) return;
    try {
      const cart = await getCart();
      setCount(cart.item_count);
      if (!cart.items.length) {
        itemsEl.innerHTML = `
          <div class="cart-drawer__empty">
            <div class="display">Leer<span style="color:var(--nb-volt)">.</span></div>
            <p>Noch nichts drin. Das ändern wir jetzt.</p>
            <p style="margin-top:20px"><a href="/collections/all" class="btn btn--volt">Jetzt shoppen</a></p>
          </div>`;
        if (footEl) footEl.style.display = 'none';
        return;
      }
      itemsEl.innerHTML = cart.items.map(drawerItemHTML).join('');
      if (footEl) {
        footEl.style.display = '';
        const totalEl = $('[data-drawer-total]');
        if (totalEl) totalEl.textContent = money(cart.total_price);
      }
    } catch (err) {
      itemsEl.innerHTML = '<div class="cart-drawer__empty"><p>Warenkorb konnte nicht geladen werden.</p></div>';
    }
  }

  async function changeLine(key, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    renderDrawer();
  }

  document.addEventListener('click', (e) => {
    const dec = e.target.closest('[data-drawer-dec]');
    const inc = e.target.closest('[data-drawer-inc]');
    const rem = e.target.closest('[data-drawer-remove]');
    if (dec) {
      const row = dec.closest('[data-line]');
      const qty = parseInt(row.querySelector('.cart-drawer__qty span').textContent, 10);
      changeLine(dec.dataset.drawerDec, Math.max(0, qty - 1));
    } else if (inc) {
      const row = inc.closest('[data-line]');
      const qty = parseInt(row.querySelector('.cart-drawer__qty span').textContent, 10);
      changeLine(inc.dataset.drawerInc, qty + 1);
    } else if (rem) {
      changeLine(rem.dataset.drawerRemove, 0);
    }
  });

  /* ---------- add to cart (product page + quick add) ---------- */
  async function addToCart(variantId, quantity, btn) {
    if (btn) btn.classList.add('is-loading');
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity }),
      });
      const cart = await getCart();
      setCount(cart.item_count);
      openDrawer();
    } catch (err) {
      if (btn) {
        const label = btn.querySelector('[data-add-to-cart-text]');
        if (label) label.textContent = 'Fehler – erneut versuchen';
      }
    } finally {
      if (btn) btn.classList.remove('is-loading');
    }
  }

  $$('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const idInput = form.querySelector('[data-variant-id]');
      const qtyInput = form.querySelector('input[name="quantity"]');
      const btn = form.querySelector('[data-add-to-cart]');
      addToCart(idInput.value, parseInt(qtyInput.value, 10) || 1, btn);
    });
  });

  $$('[data-quick-add]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      addToCart(btn.dataset.quickAdd, 1, btn);
    });
  });

  /* ---------- product page: gallery + variants + qty ---------- */
  $$('[data-product-section]').forEach((section) => {
    const mainImg = $('[data-product-main-image]', section);
    $$('[data-thumb]', section).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        $$('[data-thumb]', section).forEach((t) => t.classList.remove('active'));
        thumb.classList.add('active');
        if (mainImg && thumb.dataset.full) {
          mainImg.src = thumb.dataset.full;
          mainImg.style.opacity = '0';
          requestAnimationFrame(() => requestAnimationFrame(() => { mainImg.style.opacity = '1'; }));
        }
      });
    });

    const variantsEl = $('[data-variants-json]', section);
    const idInput = $('[data-variant-id]', section);
    const priceEl = $('[data-product-price]', section);
    const skuEl = $('[data-product-sku]', section);
    const addBtn = $('[data-add-to-cart]', section);
    const addLabel = $('[data-add-to-cart-text]', section);
    let variants = [];
    try { variants = variantsEl ? JSON.parse(variantsEl.textContent) : []; } catch (err) { /* noop */ }

    const optionInputs = $$('[data-option-index] input', section);
    function currentOptions() {
      const chosen = [];
      $$('[data-option-index]', section).forEach((group) => {
        const checked = group.querySelector('input:checked');
        chosen.push(checked ? checked.value : null);
      });
      return chosen;
    }
    function findVariant() {
      const chosen = currentOptions();
      return variants.find((v) => v.options.every((opt, i) => opt === chosen[i]));
    }
    function refreshVariantUI() {
      const variant = findVariant();
      if (!variant || !idInput) return;
      idInput.value = variant.id;
      if (priceEl) {
        priceEl.innerHTML = (variant.compare_at_price > variant.price
          ? `<s>${money(variant.compare_at_price)}</s>` : '') + money(variant.price);
      }
      if (skuEl && variant.sku) skuEl.textContent = `Art.-Nr. ${variant.sku}`;
      if (addBtn) {
        const available = variant.available;
        addBtn.disabled = !available;
        if (addLabel) {
          addLabel.textContent = available
            ? addBtn.dataset.addLabel || 'In den Warenkorb'
            : addBtn.dataset.soldoutLabel || 'Ausverkauft';
        }
      }
      // disable unavailable option values
      $$('[data-option-index]', section).forEach((group, gi) => {
        const chosen = currentOptions();
        $$('input', group).forEach((input) => {
          const possible = variants.some((v) =>
            v.available && v.options.every((opt, i) => i === gi || opt === chosen[i]) && v.options[gi] === input.value
          );
          input.disabled = !possible;
        });
      });
    }
    optionInputs.forEach((input) => input.addEventListener('change', refreshVariantUI));
    if (variants.length) refreshVariantUI();

    const qtyInput = $('input[name="quantity"]', section);
    const minus = $('[data-qty-minus]', section);
    const plus = $('[data-qty-plus]', section);
    if (minus && qtyInput) minus.addEventListener('click', () => { qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1 || 1); });
    if (plus && qtyInput) plus.addEventListener('click', () => { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });
  });

  /* ---------- cart page qty ---------- */
  $$('[data-cart-qty-minus]').forEach((btn) => btn.addEventListener('click', async () => {
    const key = btn.dataset.cartQtyMinus;
    const input = btn.parentElement.querySelector('input');
    const qty = Math.max(0, (parseInt(input.value, 10) || 1) - 1);
    await changeLine(key, qty);
    window.location.reload();
  }));
  $$('[data-cart-qty-plus]').forEach((btn) => btn.addEventListener('click', async () => {
    const key = btn.dataset.cartQtyPlus;
    const input = btn.parentElement.querySelector('input');
    const qty = (parseInt(input.value, 10) || 1) + 1;
    await changeLine(key, qty);
    window.location.reload();
  }));

  /* ---------- newsletter ---------- */
  $$('[data-newsletter-form]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const wrap = form.closest('[data-newsletter]');
      if (wrap) {
        wrap.innerHTML = '<p class="newsletter__success">Dabei! Check dein Postfach.</p>';
      }
    });
  });

  /* initial cart count */
  getCart().then((cart) => setCount(cart.item_count)).catch(() => {});
})();

/* ============================================================
   NOIRBASICS v2.1 — Slider, Lookbook, Split-Text, Magnetic,
   Custom Cursor, Grain
   ============================================================ */
(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const pad2 = (n) => String(n).padStart(2, '0');

  /* ---------- char-split headings ---------- */
  function splitChars(el) {
    if (el.classList.contains('is-split')) return;
    const process = (node) => {
      Array.from(node.childNodes).forEach((child) => {
        if (child.nodeType === 3) {
          const frag = document.createDocumentFragment();
          child.textContent.split(/(\s+)/).forEach((part) => {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
            const word = document.createElement('span');
            word.className = 'word';
            Array.from(part).forEach((ch) => {
              const c = document.createElement('span');
              c.className = 'char';
              c.textContent = ch;
              word.appendChild(c);
            });
            frag.appendChild(word);
          });
          node.replaceChild(frag, child);
        } else if (child.nodeType === 1) {
          process(child);
        }
      });
    };
    process(el);
    el.classList.add('is-split');
    $$('.char', el).forEach((c, i) => { c.style.transitionDelay = (i * 0.018).toFixed(3) + 's'; });
  }
  $$('[data-split]').forEach(splitChars);
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { threshold: 0.2 });
    $$('[data-split]').forEach((el) => io.observe(el));
  } else {
    $$('[data-split]').forEach((el) => el.classList.add('is-visible'));
  }

  /* ---------- slideshow ---------- */
  $$('[data-slideshow]').forEach((root) => {
    const slides = $$('[data-slideshow-slide]', root);
    if (!slides.length) return;
    const dots = $$('[data-slideshow-dot]', root);
    const indexEl = $('[data-slideshow-index]', root);
    const progress = $('[data-slideshow-progress]', root);
    const autoplayMs = parseInt(root.dataset.autoplay || '0', 10);
    let index = 0, timer = null, paused = false, inView = true;

    function render() {
      slides.forEach((s, i) => {
        const active = i === index;
        s.classList.toggle('is-active', active);
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
        const split = $('[data-split]', s);
        if (split) split.classList.toggle('is-visible', active);
      });
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
      if (indexEl) indexEl.textContent = pad2(index + 1);
      restartProgress();
    }
    function restartProgress() {
      if (!progress || !autoplayMs) return;
      progress.style.transition = 'none';
      progress.style.width = '0%';
      void progress.offsetWidth;
      if (!paused && inView) {
        progress.style.transition = 'width ' + autoplayMs + 'ms linear';
        progress.style.width = '100%';
      }
    }
    function go(i) {
      index = (i + slides.length) % slides.length;
      clearTimeout(timer);
      render();
      schedule();
    }
    function schedule() {
      clearTimeout(timer);
      if (!autoplayMs || paused || !inView) return;
      timer = setTimeout(() => go(index + 1), autoplayMs);
    }
    const prev = $('[data-slideshow-prev]', root);
    const next = $('[data-slideshow-next]', root);
    if (prev) prev.addEventListener('click', () => go(index - 1));
    if (next) next.addEventListener('click', () => go(index + 1));
    dots.forEach((d) => d.addEventListener('click', () => go(parseInt(d.dataset.slideshowDot, 10))));

    root.addEventListener('mouseenter', () => { paused = true; clearTimeout(timer); freezeProgress(); });
    root.addEventListener('mouseleave', () => { paused = false; render(); schedule(); });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) { clearTimeout(timer); } else { render(); schedule(); }
    });
    function freezeProgress() {
      if (!progress) return;
      const w = window.getComputedStyle(progress).width;
      progress.style.transition = 'none';
      progress.style.width = w;
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          inView = e.isIntersecting;
          if (inView) { render(); schedule(); } else { clearTimeout(timer); }
        });
      }, { threshold: 0.15 }).observe(root);
    }

    /* swipe */
    const track = $('[data-slideshow-track]', root);
    let sx = null;
    if (track) {
      track.addEventListener('pointerdown', (e) => { sx = e.clientX; });
      track.addEventListener('pointerup', (e) => {
        if (sx === null) return;
        const dx = e.clientX - sx;
        if (Math.abs(dx) > 50) go(index + (dx < 0 ? 1 : -1));
        sx = null;
      });
    }
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') go(index + 1);
      if (e.key === 'ArrowLeft') go(index - 1);
    });

    render();
    schedule();
  });

  /* ---------- lookbook drag rail ---------- */
  $$('[data-lookbook]').forEach((root) => {
    const viewport = $('[data-lookbook-viewport]', root);
    const rail = $('[data-lookbook-rail]', root);
    const bar = $('[data-lookbook-bar]', root);
    if (!viewport || !rail) return;

    function syncBar() {
      if (!bar) return;
      const max = rail.scrollWidth - rail.clientWidth;
      const p = max > 0 ? rail.scrollLeft / max : 0;
      const w = Math.max(0.12, rail.clientWidth / rail.scrollWidth);
      bar.style.width = (w * 100).toFixed(1) + '%';
      bar.style.transform = 'translateX(' + (p * (100 / w - 100)).toFixed(1) + '%)';
    }
    rail.addEventListener('scroll', syncBar, { passive: true });
    window.addEventListener('resize', syncBar);
    syncBar();

    let down = false, startX = 0, startScroll = 0, moved = 0;
    viewport.addEventListener('pointerdown', (e) => {
      down = true; moved = 0; startX = e.clientX; startScroll = rail.scrollLeft;
      viewport.classList.add('is-dragging');
      viewport.setPointerCapture(e.pointerId);
    });
    viewport.addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - startX;
      moved = Math.max(moved, Math.abs(dx));
      rail.scrollLeft = startScroll - dx;
    });
    ['pointerup', 'pointercancel'].forEach((ev) => viewport.addEventListener(ev, () => {
      down = false; viewport.classList.remove('is-dragging');
    }));
    rail.addEventListener('click', (e) => { if (moved > 8) { e.preventDefault(); e.stopPropagation(); } }, true);
    rail.addEventListener('dragstart', (e) => e.preventDefault());

    const step = () => Math.min(rail.clientWidth * 0.8, 420);
    const prev = $('[data-lookbook-prev]', root);
    const next = $('[data-lookbook-next]', root);
    if (prev) prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  /* ---------- magnetic buttons ---------- */
  if (fine) {
    $$('[data-magnetic]').forEach((el) => {
      el.addEventListener('mousemove', (e) => {
        const r = el.getBoundingClientRect();
        const x = e.clientX - r.left - r.width / 2;
        const y = e.clientY - r.top - r.height / 2;
        el.style.transform = 'translate(' + (x * 0.18).toFixed(1) + 'px,' + (y * 0.28).toFixed(1) + 'px)';
      });
      el.addEventListener('mouseleave', () => { el.style.transform = ''; });
    });
  }

  /* ---------- custom cursor ---------- */
  if (fine) {
    const dot = document.createElement('div'); dot.className = 'cursor-dot';
    const ring = document.createElement('div'); ring.className = 'cursor-ring';
    document.body.appendChild(dot); document.body.appendChild(ring);
    let mx = -100, my = -100, rx = -100, ry = -100;
    document.addEventListener('mousemove', (e) => {
      mx = e.clientX; my = e.clientY;
      dot.style.left = mx + 'px'; dot.style.top = my + 'px';
      const t = e.target.closest('a, button, [data-lookbook-viewport]');
      ring.classList.toggle('is-hovering', !!t);
    });
    (function loop() {
      rx += (mx - rx) * 0.16; ry += (my - ry) * 0.16;
      ring.style.left = rx + 'px'; ring.style.top = ry + 'px';
      requestAnimationFrame(loop);
    })();
  }

  /* ---------- film grain ---------- */
  document.body.classList.add('grain');
})();
